import React, { useState } from 'react';

interface FloatingLabelInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  status?: 'default' | 'focus' | 'error' | 'success';
  className?: string;
}

export const FloatingLabelInput: React.FC<FloatingLabelInputProps> = ({
  label,
  value,
  onChange,
  type = 'text',
  required = false,
  status = 'default',
  className = '',
  ...props
}) => {
  const [focused, setFocused] = useState(false);

  const isActive = focused || !!value;
  let borderColor = 'border-gray-400';
  let shadow = '';
  if (status === 'focus') shadow = 'shadow-md';
  if (status === 'error') borderColor = 'border-red-500';

  return (
    <div className={`relative ${className}`}>
      <input
        {...props}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        required={required}
        className={`block w-full rounded-lg border-2 bg-white px-4 pb-2 pt-6 text-base dark:bg-neutral-900 ${borderColor} ${shadow} transition-all`}
      />
      <label
        className={`pointer-events-none absolute left-4 text-gray-500 transition-all ${isActive ? 'top-1.5 -translate-y-0 text-xs' : 'top-1/2 -translate-y-1/2 text-base'}`}
      >
        {label} {!required && <span className="text-gray-400">(optional)</span>}
      </label>
    </div>
  );
};
